// fetch with GET does not allow body data
export function getApi(url, headers = false) {
	if(!url) {
		let res = {};
		$('.icon-spinner').removeClass('is-active');
		$('.loading-spinner').removeClass('is-active');
		return Promise.resolve(res);
	}
	return fetch(url, {
		credentials: 'same-origin', // 'same-origin. include'
		headers: (headers) ? new Headers(headers) : new Headers({})
	})
	.then((response) => {
		if(!response.ok) throw new Error(response.status);
		else return response.json();
	})
	.then((response) => Promise.resolve(response))
	.catch((error) => {
		Promise.reject(error);
		$('.icon-spinner').removeClass('is-active');
		$('.loading-spinner').removeClass('is-active');
	});
}

// fetch with POST and others (DELETE, etc.)
export function callApi(url, data = {}, method = 'POST') {
	if(!url) {
		let res = {};
		$('.icon-spinner').removeClass('is-active');
		$('.loading-spinner').removeClass('is-active');
		return Promise.resolve(res);
	}
	return fetch(url, {
		method: method,
		body: JSON.stringify(data),
		credentials: 'same-origin', // 'same-origin, include'
		headers: new Headers({
			'Content-Type': 'application/json'
		})
	})
	.then((response) => {
		if(!response.ok) throw new Error(response.status);
		else return response.json();
	})
	.then((response) => Promise.resolve(response))
	.catch((error) => {
		Promise.reject(error);
		$('.icon-spinner').removeClass('is-active');
		$('.loading-spinner').removeClass('is-active');
	});
}

export function isSuccessful(data) {
	return (data.status == 200 || data.status == 'SUCCESS');
}
